"use client"

import { Button } from "@/components/ui/button"
import { Loading } from "@/app/components/Loading"

interface ImportActionButtonProps {
  exportFile: File | null
  posts: any[] | null
  isLoading: boolean
  importFinished: boolean
  onAction: () => void
}

/**
 * Action button that changes text and behavior based on import state
 */
export function ImportActionButton({
  exportFile,
  posts,
  isLoading,
  importFinished,
  onAction,
}: ImportActionButtonProps) {
  if (!exportFile && !posts) return null

  return (
    <Button
      disabled={(!posts && !exportFile) || importFinished || isLoading}
      className="max-w-[200px]"
      onClick={onAction}
    >
      {isLoading ? (
        <span className="flex items-center gap-2">
          <Loading className="h-4 w-4" />
          <span className="-ml-1 mr-2">
            {posts ? "Importing..." : "Processing..."}
          </span>
        </span>
      ) : importFinished ? (
        "Imported!"
      ) : posts ? (
        "Acknowledge & Import"
      ) : (
        "Process File"
      )}
    </Button>
  )
}
